import { render, staticRenderFns } from "./FoodDB.vue?vue&type=template&id=511652fc&scoped=true&"
import script from "./FoodDB.vue?vue&type=script&lang=js&"
export * from "./FoodDB.vue?vue&type=script&lang=js&"
import style0 from "./FoodDB.vue?vue&type=style&index=0&id=511652fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511652fc",
  null
  
)

export default component.exports